module.exports = __webpack_public_path__ + "img/SueloArtificial.7859e988.jpg";